import __request__ from "routing/request";
export function createConfig(config, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/data_lake/backends", config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/backends", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getActiveBackendType(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lake/backends/active/type", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfig(config, backendId, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${backendId}`, config, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfig(backendId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, wipe_storage = false, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datalake/data_lake/backends/${id}`, null, { "wipe_storage": wipe_storage }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
